import { collection, getDocs, query, runTransaction } from 'firebase/firestore';
import { db } from '@/firebase';
import { getTenantCollectionPath } from '../utils/firebase';

async function updateTagInProducts(id, tagData) {
	await runTransaction(db, async (transaction) => {
		const productsRef = collection(db, getTenantCollectionPath('products'));
		const snapshot = await getDocs(productsRef);

		if (!snapshot.empty) {
			snapshot.docs.forEach((productDoc) => {
				const productData = productDoc.data();
				const hasTags =
					productData.tags &&
					Array.isArray(productData.tags) &&
					productData.tags.some((tag) => tag.id == id);

				if (hasTags) {
					const updatedTags = productData.tags.map((tag) => {
						if (tag.id == id) {
							return {
								id: id,
								name: tagData.name,
							};
						}
						return tag;
					});

					transaction.update(productDoc.ref, {
						tags: updatedTags,
						updatedAt: new Date(),
					});
				}
			});
		}
	});
}

export class TagFunctions {
	static async updateTag(id, tagData) {
		await updateTagInProducts(id, tagData);
	}
}
